import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { InputComponent } from '../../../components/inputs/input.component';
import { ButtonComponent } from '../../../components/buttons/button.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { ToastService } from '../../../../utils/toast.service';
import { AuthService } from '../../../../modules/authentication/services/auth.service';

@Component({
  selector: 'app-confirm-password',
  standalone:true,
  imports:[RouterLink,CommonModule,InputComponent,ButtonComponent],
  templateUrl: './confirm-password.component.html'
})
export class ConfirmPasswordComponent implements OnInit {
authService = inject(AuthService);
  private readonly toastService = inject(ToastService);
  private readonly routerLink = inject(Router);
  loading = false; 
  passwordFirstControl = new FormControl('', [Validators.required]);
  passwordSecondControl = new FormControl('', [Validators.required]);
  token: string | null = null;

  router = inject(ActivatedRoute);

  ngOnInit(): void {
    this.router.queryParamMap.subscribe(async params => {
       this.token = params.get('token');
       if(await this.authService.isTokenExpired(this.token)){
         this.showTokenExpiredToast();
       }
     });
  }
  
  isPasswordMatch(): boolean {
    return this.passwordFirstControl.value === this.passwordSecondControl.value;
  }

  async recoveryPassword(): Promise<void> {
    if (this.isFormInvalid()) {
      this.showInvalidPasswordToast();
      return;
    }

    if (!this.token) {
      this.showTokenExpiredToast();
      return;
    }

    this.loading = true;

    try {
      await this.authService.confirmResetPassword(
        this.token,
        this.passwordSecondControl.value ?? ''
      );
      this.showSuccessToast();
      this.routerLink.navigateByUrl('/auth');

    } catch (error) {
      this.showGenericErrorToast();
    } finally {
      this.loading = false;
    }
  }

  private isFormInvalid(): boolean {
    return (
      this.passwordFirstControl.invalid ||
      this.passwordSecondControl.invalid ||
      !this.isPasswordMatch()
    );
  }

  private showTokenExpiredToast(): void {
    this.toastService.showToast(
      'fi fi-ss-diamond-exclamation text-[24px] text-[#FF3030]',
      'El enlace no es válido o ha expirado. Por favor, inicia nuevamente el proceso para recuperar tu contraseña',
      'error'
    );
  }

  private showInvalidPasswordToast(): void {
    this.toastService.showToast(
      'fi fi-ss-diamond-exclamation text-[24px] text-[#FF3030]',
      'Las contraseñas no coinciden o no son válidas.',
      'error'
    );
  }

  private showSuccessToast(): void {
    this.toastService.showToast(
      'fi fi-ss-check-circle text-[24px] text-[#17BF33]',
      'Contraseña actualizada de manera exitosa.',
      'success'
    );
  }

  private showGenericErrorToast(): void {
    this.toastService.showToast(
      'fi fi-ss-diamond-exclamation text-[24px] text-[#FF3030]',
      'No fue posible crear la nueva contraseña. Por favor, inténtalo nuevamente.',
      'error'
    );
  }
}